import React, { useState, Fragment, useEffect } from 'react';

import InputFieldDataProfile from "../../../components/InputFieldDataProfile";
import { useUpdateDataMutation, useDiscordTestPrivateMsgMutation } from '../../../services/accountsApi';

import editIcon from "../../../img/pencil-icon.svg";
import saveIcon from '../../../img/save-icon.svg';
import cancelIcon from '../../../img/close-icon-button.svg';
import { Button, Box } from '@mui/material';
import { useNotification } from '../../../context/NotificationContext';
import { discordSchema } from "../../../validations/discordValidation";

const DiscordField = ({ user, setUser }) => {

  const { showNotification } = useNotification();

  const [initUpdateData, {isLoading: updateDataIsLoading}] = useUpdateDataMutation();
  const [initDiscordTestPrivateMsg, {isLoading: discordTestPrivateMsgIsLoading}] = useDiscordTestPrivateMsgMutation();

  function PencilOrangeIconSvg() {
    return <img src={editIcon} alt="edit icon" height="18px" width="18px" />;
  }
  const [userInformation, setUserInformation] = useState({ ...user});
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    setUserInformation((prev) => {
      return {
        ...user,
        discordTag: prev.discordTag
      }
    })
  }, [user])



  const [error, setError] = useState([]);

  const closeEditForm = () => {
    setCanEdit(false);
    setError([]);
  };

  async function onLocalSubmit() {
    try {

      if( userInformation.discordTag.length > 0 ){
        await discordSchema.validate({discordUserName:userInformation.discordTag}, { abortEarly: false });
      }else{
        setUserInformation({ ...user,discordTag: null})
      }

      setError([])
      sendData();
    } catch (err) {
      console.log(err.errors)
      console.log(err.name)
      if (err.name == "ValidationError") {
        setError(err.errors);
      }
      //A: yup validation errorsMessages 
    }
  }

  function onLocalCancel() {
    setUserInformation({ ...userInformation, discordTag: user.discordTag });
    closeEditForm();
  }

  async function sendData() {

    try {
      setUser(await initUpdateData({id:user.id, body:userInformation}).unwrap())
    } catch (error) {
      setUserInformation({ ...user })
      console.log("error updating user: " + error);
    }

    closeEditForm();
  }

  async function testDiscordPrivateMsg() {
    if (userInformation.discordTag == null || userInformation.discordTag == "") {
      showNotification('Enter a Discord Tag', 'error');
    }
    try {
      let res = await initDiscordTestPrivateMsg({discordTag: userInformation.discordTag}).unwrap();
      console.log("discordTest, success: ", res)
      showNotification('A direct message has been sent to you on the EncoreHive Discord server. If you haven’t received that, please contact an Administrator for help to ensure you can receive EncoreHive notifications.', 'success');
    } catch (error) {
      console.log("discordTest, error: ", error)
      showNotification('Error Sending Test Message', 'error');
    }

  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <InputFieldDataProfile
            label="My Discord User Name"
            value={userInformation.discordTag}
            onChange={(e) => { setUserInformation((prevState) => { return { ...prevState, ['discordTag']: e.target.value } }) }}
            edit={canEdit}
            // ? 
            InputProps={canEdit ? {style: { border: "1px solid var(--greyblue)", borderRadius: "5px", padding: "0.2em 0.75em", width: "250px", margin: "0 1px"}, labelMargin:"0"} : {}}
          />
        </Box>

        <Box className="edit-button-container">
          {canEdit ? (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>

              <div className="container-button-form">

                <Button
                  className="btn-save-form"
                  onClick={onLocalSubmit}
                >
                  <img src={saveIcon} alt='Save Icon' height='18px' style={{ marginRight: '1em' }} />
                  <span style={{ color: ' var(--orange) ' }}>Save</span>
                </Button>

                <Button className="btn-cancel-form" onClick={onLocalCancel}>
                  <img src={cancelIcon} alt='Cancel Icon' height='18px' style={{ marginRight: '0.25em' }} />
                  <span style={{ color: ' var(--orange) ' }}>Cancel</span>
                </Button>

              </div>

            </div>
          ) : (
            <Fragment>

              <Button variant="outlined" onClick={testDiscordPrivateMsg} sx={{ margin: '0 0.5em 0 0' }} >
                TEST
              </Button>

              <Button
                className="button-edit"
                onClick={() =>
                  setCanEdit(true)
                }
              >
                <PencilOrangeIconSvg />
                <span style={{ marginLeft: "0.5em", color: ' var(--orange) ' }}>Edit</span>
              </Button>

            </Fragment>

          )}
        </Box>

      </Box>
      <Box sx={{ display: "flex" }}>
        {error && error.length > 0 && <ul style={{ color: 'var(--red)' }} >
          {error.map((err) => (
            <li key={err}>{err}</li>
          ))}
        </ul>}
      </Box>
    </Box>

  )
}

export default DiscordField;